import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\">\r\n<path d=\"M2 9.33325L2.1559 9.77496C2.76267 11.4941 3.06605 12.3537 3.75828 12.8435C4.45051 13.3333 5.36206 13.3333 7.18518 13.3333H8.81482C10.6379 13.3333 11.5495 13.3333 12.2417 12.8435C12.934 12.3537 13.2373 11.4941 13.8441 9.77496L14 9.33325\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n<path d=\"M7.99935 2.66683L7.99935 9.3335M7.99935 2.66683C8.46617 2.66683 9.33833 3.99636 9.66602 4.3335M7.99935 2.66683C7.53253 2.66683 6.66037 3.99636 6.33268 4.3335\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/upload.svg
// module id = P/TB
// module chunks = 36